<el-main class="main">
    <div
            class="calculate-container">
        <el-form
                ref="formRef"
                :model="dataForm"
                :rules="formRules"
                class="form"
                label-position="top">

            <div class="container">

                <div
                        class="container__item"
                >
                    <el-form-item prop="sender.cityFrom" class="calculate-container__city" label="Город отправителя">
                        <el-select
                                value-key="id"
                                v-model="dataForm.sender.cityFrom"
                                placeholder="Выберите город"
                                @change="useFetchSuitableOfficesCalculator('acceptanceCargo')"
                                filterable
                                v-cancel-read-only
                        >
                            <el-option
                                    v-for="(city, index) in citiesSender"
                                    :key="index"
                                    :label="city.title"
                                    :value="city"
                                    :disabled="disableIdenticalCity(city.title,'from')"
                                    @change="console.log('test')"

                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="calculator.isCargoPickup"
                                  class="calculate-container__radio-group font-size--12">
                        <el-radio-group
                                :disabled="!dataForm.sender.cityFrom"
                                class="font-size_el-radio-button__inner el-radio-button__type-payment"
                                v-model="dataForm.calculator.isCargoPickup"
                                @change="setCargoPickup"
                        >
                            <el-radio-button
                                    key="Забор груза"
                                    label="Забор груза"
                                    value="Забор груза"
                            />
                            <el-radio-button
                                    :disabled="newDataForm.fetchedSuitableOffices.pickUp.length === 0"
                                    key="Сдать на склад"
                                    label="Сдать на склад"
                                    value="Сдать на склад"
                            />
                        </el-radio-group>
                    </el-form-item>
                </div>

                <!-- <img class="reverse" src="@/assets/reverse.png" alt="" @click="swapCities"> -->

                <div class="container__item">
                    <el-form-item prop="consignee.cityTo" class="calculate-container__city" label="Город получателя">
                        <el-select
                                value-key="id"
                                v-model="dataForm.consignee.cityTo"
                                @change="setPickupPossibility(dataForm.consignee.cityTo)"
                                placeholder="Выберите город"
                                filterable
                                v-cancel-read-only
                        >
                            <el-option
                                    v-for="(city, index) in citiesConsignee"
                                    :key="index"
                                    :label="city.title"
                                    :value="city"
                                    :disabled="disableIdenticalCity(city.title,'to')"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="calculator.isDelivery" class="calculate-container__radio-group font-size--12">
                        <el-radio-group
                                class="font-size_el-radio-button__inner el-radio-button__type-payment"
                                v-model="dataForm.calculator.isDelivery"
                                :disabled="!dataForm.consignee.cityTo"
                                @change="setDelivery"
                        >
                            <el-radio-button
                                    key="Доставка до адреса"
                                    label="Доставка до адреса"
                                    value="Доставка до адреса"
                            />
                            <el-radio-button
                                    :disabled="newDataForm.fetchedSuitableOffices.delivery.length === 0"
                                    key="Забрать на складе"
                                    label="Забрать на складе"
                                    value="Забрать на складе"
                            />
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>

            <div class="container">
                <div class="container__item">
                </div>
                <div class="container__item">
                    <el-form-item>
                        <el-switch
                                v-model="isTotalVolume"
                                inactive-text="Габариты груза"
                                active-text="Общий объём"
                                @change="changeTotalVolume"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="container">
                <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
                    <el-form-item>
                        <el-col :span="11">
                            <el-form-item prop="cargoInformation.typeOfCargo" label="Вид груза">
                                <el-select v-model="dataForm.cargoInformation.typeOfCargo"
                                           placeholder="Выберите вариант"
                                           @change="clearSizeByCargoForm"
                                >
                                    <el-option v-for="type in typeOfCargos" :key="type.value" :label="type.label"
                                               :value="type.value"/>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2"/>
                        <el-col :span="11">
                            <el-form-item prop="cargoInformation.numberOfIdenticalLoads" label="Количество мест">
                                <el-input v-model="dataForm.cargoInformation.numberOfIdenticalLoads" min="1"
                                          type="number" class="hidden_el-input-group__append"
                                          @change="checkNumberOfIdenticalLoads">
                                    <template #append>шт.</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </div>
                <div class="container__item align-items--flex-end_el-form-item__content container__item--order--0">
                    <template v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                        <el-form-item v-if="dataForm.cargoInformation.typeOfCargo === 'Цилиндры' && !isTotalVolume"
                                      label="Габариты груза">
                            <template #label>Габариты груза<span>, см</span></template>
                            <el-col :span="6">
                                <el-form-item prop="cargoInformation.sizeOfCargoCylinder.height">
                                    <el-input
                                            type="number"
                                            placeholder="В"
                                            v-model="dataForm.cargoInformation.sizeOfCargoCylinder.height"
                                            min="0"
                                            class="hidden_el-input-group__append"
                                            @change="dimensionsCargoChange('sizeOfCargoCylinder.height')"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" class="multiplication">х</el-col>
                            <el-col :span="6">
                                <el-form-item prop="cargoInformation.sizeOfCargoCylinder.diameter">
                                    <el-input
                                            type="number"
                                            placeholder="Д"
                                            v-model="dataForm.cargoInformation.sizeOfCargoCylinder.diameter"
                                            min="0"
                                            class="hidden_el-input-group__append"
                                            @change="dimensionsCargoChange('sizeOfCargoCylinder.diameter')"
                                    >
                                        <template #append>см</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>

                        <el-form-item v-else-if="!isTotalVolume" label="Габариты груза">
                            <template #label>Габариты груза<span>, см</span></template>
                            <el-col :span="6">
                                <el-form-item prop="cargoInformation.cargoDimensions.length">
                                    <el-input
                                            type="number"
                                            placeholder="Д"
                                            v-model="dataForm.cargoInformation.cargoDimensions.length"
                                            min="0"
                                            class="hidden_el-input-group__append"
                                            @change="dimensionsCargoChange('cargoDimensions.length')"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" class="multiplication">х</el-col>
                            <el-col :span="6">
                                <el-form-item prop="cargoInformation.cargoDimensions.width">
                                    <el-input
                                            type="number"
                                            placeholder="Ш"
                                            v-model="dataForm.cargoInformation.cargoDimensions.width"
                                            min="0"
                                            class="hidden_el-input-group__append"
                                            @change="dimensionsCargoChange('cargoDimensions.width')"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" class="multiplication">х</el-col>
                            <el-col :span="6">
                                <el-form-item prop="cargoInformation.cargoDimensions.height">
                                    <el-input
                                            type="number"
                                            placeholder="В"
                                            v-model="dataForm.cargoInformation.cargoDimensions.height"
                                            min="0"
                                            class="hidden_el-input-group__append"
                                            @change="dimensionsCargoChange('cargoDimensions.height')"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </template>
                </div>

                <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
                    <el-form-item>
                        <el-col :span="11">
                            <el-form-item prop="services.isSenderInn" label="Плательщик перевозки">
                                <el-select
                                        v-model="dataForm.services.isSenderInn"
                                        placeholder="Выберите плательщика"
                                        filterable
                                        v-cancel-read-only>
                                    <el-option
                                            v-for="type in typeOfPayer" :key="type.value"
                                            :label="type.label"
                                            :value="type.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2"/>
                        <el-col :span="11">
                            <el-form-item prop="cargoInformation.cargoCost" label="Объявленная стоимость груза">
                                <el-input
                                        type="number"
                                        v-model="dataForm.cargoInformation.cargoCost"
                                        min="0"
                                        @change="checkCargoCost"
                                />
                                <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoCost >= 30000)">
                                    Обрешетка может быть обязательной - в зависимости от <a target="_blank"
                                                                                            href="https://xn----stbeziy.xn--p1ai/dlya-klienta/udorozhanie">характера груза</a>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </div>
                <div v-bind:style="{justifyContent:'flex-end'}"
                     class="container__item align-items--flex-end_el-form-item__content container__item--order--2">
                    <el-form-item v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                        <el-col :span="11">
                            <el-form-item prop="cargoInformation.cargoWeight" label="Общая масса">
                                <template #label>Общая масса<span class="hidden-pc">, кг</span></template>
                                <el-input
                                        type="number"
                                        @change="dimensionsCargoChange"
                                        v-model="dataForm.cargoInformation.cargoWeight"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                >
                                    <template #append>кг</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2"/>
                        <el-col :span="11">
                            <el-form-item v-if="dataForm.cargoInformation.typeOfCargo !== 'Цилиндры' && isTotalVolume"
                                          prop="cargoInformation.typeOfCargo"
                                          label="Общий объём">
                                <template #label>Общий объём<span class="hidden-pc">, м&#179</span></template>
                                <el-input
                                        type="number"
                                        v-model="dataForm.cargoInformation.cargoVolume"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                        @change="calculateDimensions(dataForm.cargoInformation.typeOfCargo)"
                                >
                                    <template #append>м&#179</template>
                                </el-input>
                            </el-form-item>

                            <el-form-item v-if="dataForm.cargoInformation.typeOfCargo === 'Цилиндры' && isTotalVolume"
                                          prop="cargoInformation.typeOfCargo"
                                          label="Общий объём">
                                <template #label>Общий объём<span class="hidden-pc">, м&#179</span></template>
                                <el-input
                                        type="number"
                                        v-model="dataForm.cargoInformation.cargoVolume"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                        @change="calculateDimensions(dataForm.cargoInformation.typeOfCargo)"
                                >
                                    <template #append>м&#179</template>
                                </el-input>
                            </el-form-item>

                            <el-form-item v-else-if="!isTotalVolume && isTotalVolume"
                                          prop="cargoInformation.cargoVolume" label="Общий объём">
                                <template #label>Общий объём<span class="hidden-pc">, м&#179</span></template>
                                <el-input
                                        type="number"
                                        v-model="dataForm.cargoInformation.cargoVolume"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                        @change="calculateDimensions(dataForm.cargoInformation.typeOfCargo)"
                                >
                                    <template #append>м&#179</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item v-else-if="!isTotalVolume" label="Общий объём">
                                <template #label>Общий объём<span class="hidden-pc">, м&#179</span></template>
                                <el-col :span="20">
                                    {{
                                        dataForm.cargoInformation.cargoVolume
                                    }}
                                </el-col>
                                <el-col :span="1"/>
                                <el-col :span="3">
                                    м&#179
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </div>
            </div>

            <el-form-item class="align-items--flex-end_el-form-item__content">
                <el-col :span="11">
                    <el-form-item prop="services.cargoRedemption">
                        <el-switch
                                v-model="dataForm.services.cargoRedemption"
                                active-text="Выкуп груза"
                                :disabled="dataForm.services.cashOnDelivery"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="2"/>
                <el-col :span="11">
                    <el-form-item prop="services.cargoRedemptionSum" label="Сумма выкупа груза">
                        <el-input
                                v-model="dataForm.services.cargoRedemptionSum"
                                :disabled="!dataForm.services.cargoRedemption"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item prop="services.cashOnDelivery" class="align-items--flex-end_el-form-item__content">
                <el-col :span="11">
                    <el-form-item>
                        <el-switch
                                v-model="dataForm.services.cashOnDelivery"
                                active-text="Наложенный платёж"
                                :disabled="dataForm.services.cargoRedemption"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="2"/>
                <el-col :span="11">
                    <el-form-item prop="services.cashOnDeliverySum" label="Сумма наложенного платежа">
                        <el-input v-model="dataForm.services.cashOnDeliverySum"
                                  :disabled="!dataForm.services.cashOnDelivery"/>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--30">
                <el-col :span="11">
                    <el-form-item prop="cargoInformation.additionalPackaging">
                        <el-switch
                                v-model="dataForm.cargoInformation.additionalPackaging"
                                active-text="Доп. упаковка"
                                @change="dataForm.cargoInformation.typeOfPackaging = dataForm.cargoInformation.additionalPackaging ? dataForm.cargoInformation.typeOfPackaging : []"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="2"/>
                <el-col :span="11">
                    <el-form-item
                            class="cargo-information-container__type-of-packaging"
                            prop="cargoInformation.typeOfPackaging"
                            label="Тип упаковки"
                    >
                        <!-- :required="dataForm.cargoInformation.additionalPackaging" -->
                        <el-select
                                v-model="dataForm.cargoInformation.typeOfPackaging"
                                placeholder="Выберите вариант"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                :disabled="!dataForm.cargoInformation.additionalPackaging"
                                @change="checkPackageType"
                        >
                            <el-option
                                    v-for="type in typeOfPackagings"
                                    :key="type.value"
                                    :label="type.label"
                                    :value="type.value"
                                    :disabled="checkIntersectionsTypes(type.disabled, type.label, type.label)"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form-item>


            <el-form-item prop="services.warmPlace" class="margin-bottom--30 align-items--flex-start">
                <el-col :span="11">
                    <el-form-item>
                        <!-- <el-tooltip effect="dark" content="Услуга приостановлена на летний сезон" placement="top"> -->
                            <el-switch
                                    v-model="dataForm.services.warmPlace"
                                    active-text="Тёплое место"
                                    :disabled="checkDisabledWarmplace()"
                            />
                        <!-- </el-tooltip> -->
                    </el-form-item>
                    <!-- <div class="warmplace__text"
                         v-if="dataForm.cargoInformation.cargoWeight > (30 * dataForm.cargoInformation.numberOfIdenticalLoads)">
                        Максимальная масса -
                        {{ 30 * dataForm.cargoInformation.numberOfIdenticalLoads }}кг
                    </div> -->
                </el-col>
                <el-col :span="2"/>
                <el-col :span="11">
                    <el-form-item prop="services.returnOfDocuments">
                        <el-switch
                                v-model="dataForm.services.returnOfDocuments"
                                active-text="Возврат документов"
                        />
                    </el-form-item>
                </el-col>
            </el-form-item>

            <div class="button__send-forwardin-receipt">
                <el-form-item>
                    <el-button
                            class="button_box-shadow"
                            type="primary"
                            @click="submitForm(formRef)"
                    >
                        Рассчитать
                    </el-button>
                </el-form-item>
            </div>
            <div class="table__td score score-phone">
                Итоговая сумма:
                {{ calculatedData.shippingCost.total || "0" }}
            </div>
        </el-form>

        <div class="module module_up">
            <div class="hiddenLinks">
                <el-button @click="goToCargoPickup">Оформить заявку на груз</el-button>
                <!-- <el-button @click="$router.push({name: 'forwardingReceipt'})">Оформить экспедиторскую расписку</el-button> -->
            </div>
            <div class="module__item">
                <h4>Общие данные по грузу</h4>
                <div class="item__table">
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Общий объём
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.totalVolume || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Общий вес
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.totalWeight || "0" }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="module__item" :class="{module_item_up: showLinkButtons}">
                <h4>Стоимость перевозки</h4>
                <div class="item__table">
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Перевозка "Cклад-склад"
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.transportation || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Забор груза
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.cargoPickUp || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Доплата за отдалённый адрес на заборе
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.extraChargeForCargoPickUp || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Доставка по городу
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.cargoDelivery || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Доплата за отдалённый адрес на доставку
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.extraChargeForCargoDelivery || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--center">
                            Дополнительные услуги:
                        </div>
                        <!-- <div class="table__td_text-align--right">
                        </div> -->
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Дополнительная упаковка
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.package || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Тёплое место
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.warmPlace || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Комиссия на наложенный платеж
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.cashOnDeliveryAmount || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Комиссия за выкуп груза
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.costForTheRedemptionOfCargo || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Удорожание от объявленной стоимости
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.costWarranty || "0" }}
                        </div>
                    </div>
                    <div class="table__td">
                        <div class="table__td_text-align--left">
                            Возврат документов
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.costForReturningDocuments || "0" }}
                        </div>
                    </div>
                    <!-- <div class="table__td">
                      <div class="table__td_text-align--left">
                        Стоимость за ожидание на заборе:
                      </div>
                      <div class="table__td_text-align--right">
                        {{ calculatedData.shippingCost.costForWaitingOnPickUp || "0" }}
                      </div>
                    </div> -->
                    <!-- <div class="table__td">
                      <div class="table__td_text-align--left">
                        Стоимость за ожидание на доставке:
                      </div>
                      <div class="table__td_text-align--right">
                        {{ calculatedData.shippingCost.costForWaitingOnDelivery || "0" }}
                      </div>
                    </div> -->
                    <div class="table__td score">
                        <div class="table__td_text-align--left">
                            Итоговая сумма:
                        </div>
                        <div class="table__td_text-align--right">
                            {{ calculatedData.shippingCost.total || "0" }}
                        </div>
                    </div>
                    <!--                    <div class="container-button">-->
                    <!--                        <router-link :to="linkToCreateAnApplication()" class="button-link">-->
                    <!--                            <el-button-->
                    <!--                                    class="button_box-shadow"-->
                    <!--                                    type="primary"-->
                    <!--                            >-->
                    <!--                                Оформление заявки-->
                    <!--                            </el-button>-->
                    <!--                        </router-link>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>

    </div>
</el-main>
